import AuthContext from '../../../app/contexts/auth';
import ConnectionProvider from '../../../app/contexts/connection';
import RoundsPage from './rounds-page';

export default function Rounds() {
    const { user } = AuthContext.useAuth();

    return (
        <ConnectionProvider.ConnectionProvider
            group="Global"
            sulaHubId={user?.carrier?.sulahub_id}
        >
            <RoundsPage />
        </ConnectionProvider.ConnectionProvider>
    );
}
